import Axios from "axios";
import { handleApiError } from "./config";

export function postResponse(message, phoneNr) {
  return new Promise((resolve, reject) => {
    Axios.post("response", {
      text: message,
      phone: phoneNr
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err);
        return reject(err);
      });
  });
}


export function patchResponse(id, text) {
  return new Promise((resolve, reject) => {
    Axios.patch(`response/${id}`, {
      text: text,
    })
      .then((res) => {
        return resolve(res.data);
      })
      .catch((err) => {
        handleApiError(err);
        return reject(err);
      });
  });
}
